import React, { useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import { track } from '~/src/dash/analytics/analytics';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { SimpleTabs } from '~/src/dash/components/tabs/SimpleTabs';
import { SimpleTabSections } from '~/src/dash/components/tabs/SimpleTabSections';
import { Panel, Panels, spacing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { IS_AUTHORIZED } from '~/src/dash/utils/permission_service';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { useBaseConfig, useBaseStore } from '~/src/dash/views/base/contexts';
import { BidderGroupsListView } from '~/src/dash/views/bidders/Bidders/tabs/BidderGroupsListView';
import { BiddersDemandSourceSettings } from '~/src/dash/views/bidders/Bidders/tabs/BiddersDemandSourceSettings';
import { BiddersListView } from '~/src/dash/views/bidders/Bidders/tabs/BiddersListView';
import { IBiddersConfig } from '~/src/dash/views/bidders/config';
import { BiddersListContext } from '~/src/dash/views/bidders/contexts';

export const Bidders = () => {
  const { classes, location, session, user } = useBaseStore();
  const { Bidders } = useBaseConfig();
  const cfg = Bidders.Main as IBiddersConfig;
  const isSuperUser = hasRoleSuperUser(user.user);

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [key, setKey] = useState(0);

  // other consts
  const readAuthorization = IS_AUTHORIZED(['read_bidder'], user.user);
  const writeAuthorization = IS_AUTHORIZED(['write_bidder'], user.user);
  const { pathname } = location;

  const handleChangeTab = (_event: React.SyntheticEvent, index: number) => {
    const tabKey = cfg.tabs.find((tab) => tab.value === index)?.key;
    track(`Bidder List - View ${tabKey} Tab`, { isSuperUser }, user.user);
    setActiveTabIndex(index);
  };

  const forceUpdate = (tabIndex: number) => {
    unstable_batchedUpdates(() => {
      setActiveTabIndex(tabIndex);
      setKey((value) => value + 1);
    });
  };

  return (
    <BiddersListContext.Provider
      value={{
        cfg,
        readAuthorization,
        writeAuthorization,
        forceUpdate,
      }}
    >
      <Panels max vertical relative minWidthMain>
        <Panel
          largeHorizontalPadding
          verticalPadding
          style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
        >
          <ModelTopBar
            classes={classes}
            currentPath={pathname}
            disableTitlePaddingLeft
            publisher={session.publisher}
            session={session}
            title={routeName(pathname)}
            user={user}
          />
        </Panel>
        <Panel>
          <SimpleTabs
            activeTabIndex={activeTabIndex}
            ariaLabel='Bidders'
            handleChangeTab={handleChangeTab}
            tabs={cfg.tabs}
          />
        </Panel>
        <Panel scroll paddingTop={spacing.small}>
          <SimpleTabSections
            key={key}
            activeTabIndex={activeTabIndex}
            sections={[BiddersListView, BidderGroupsListView, BiddersDemandSourceSettings]}
          />
        </Panel>
      </Panels>
    </BiddersListContext.Provider>
  );
};
